<template lang="pug">
.card-list
  .card-title {{ title }}
  .card-content
    slot
    .card-button( v-if="!!$slots['footerButton']").border-light-top
      slot(name="footerButton")
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.card-list {
  .card-title {
    color: #1F394A;
    font-size: 16px;
    padding-left: 10px;
    margin-bottom: 10px;
    text-align: center;
  }

  .card-button {
    & > div {
      background-color: white;
      border-radius: 5px;
      color: #0360FF;
      font-size: 1rem;
      transition: background-color .3s;

      &:hover {
        cursor: pointer;
        background-color: #EFF5FF;
      }

      i {
        font-size: 1.5rem;
        margin-right: .5rem;
      }
    }
  }
}
</style>
